import React, { useState } from "react";
import { formatCrypto, formatCurrency, getAssetName } from "../../utils";
import moment from "moment";
import SkeletonCard from "../skeletons/SkeletonCard";
import Pagination from "../commons/Pagination";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/solid"; // Optional: For up/down arrows
import { ArrowDownIcon, ArrowUpIcon } from "@heroicons/react/24/outline";

const TablePortoHistory = ({
  histories,
  loadingHistories,
  page,
  setPage,
  sortField,
  sortDirection,
  setSortField,
  setSortDirection,
}) => {
  const headers = [
    { label: "Pair", key: "asset_name" },
    { label: "Exchange", key: "exchange_name" },
    { label: "BOT", key: "bot_master_name" },
    { label: "Side", key: "side" },
    { label: "Amount", key: "qty" },
    { label: "Price", key: "price" },
    { label: "Total", key: "usdt_qty" },
    { label: "Date", key: "created_at" },
  ];

  const handleSort = (key) => {
    if (sortField === key) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortField(key);
      setSortDirection("asc");
    }
  };

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-4 ">
      <div className="overflow-x-auto">
        <table className="min-w-full text-sm text-left">
          <thead>
            <tr>
              {headers.map(({ label, key }) => (
                <th
                  key={key}
                  onClick={() => handleSort(key)}
                  className="px-3 !text-sm py-2 font-bold text-[#21272A] cursor-pointer select-none"
                >
                  <div className="flex items-center gap-1">
                    {label}
                    {sortField === key ? (
                      sortDirection === "asc" ? (
                        <ArrowUpIcon className="w-4 h-4 text-blue-600" />
                      ) : (
                        <ArrowDownIcon className="w-4 h-4 text-blue-600" />
                      )
                    ) : (
                      <ArrowDownIcon className="w-4 h-4 text-gray-300" />
                    )}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loadingHistories ? (
              [...Array(10)].map((_, idx) => (
                <tr key={idx} className="border-b bg-white">
                  {[...Array(headers.length)].map((_, i) => (
                    <td key={i} className="p-4 text-sm">
                      <SkeletonCard
                        type="text"
                        lines={1}
                        widths={["60px"]}
                        heights={["10px"]}
                      />
                    </td>
                  ))}
                </tr>
              ))
            ) : histories?.data?.length ? (
              histories?.data?.map((item, index) => (
                <tr key={index} className="border-b hover:bg-gray-50">
                  <td className="p-4 text-sm !font-normal">
                    {item.asset_name}
                  </td>
                  <td className="p-4 text-sm !font-normal">
                    <div className="flex gap-1 items-center capitalize">
                      <img
                        src={`/images/icons/icon_wallet_${item.exchange_name}.svg`}
                        alt=""
                        className="w-full max-w-[20px] h-[20px] rounded-full mr-2"
                      />
                      {item.exchange_name}
                    </div>
                  </td>
                  <td className="p-4 text-sm !font-normal">
                    {item.bot_master_name}
                  </td>
                  <td
                    className={`p-4 text-sm font-bold capitalize ${
                      item.side === "sell"
                        ? "text-red-500"
                        : item.side === "buy"
                        ? "text-green-600"
                        : ""
                    }`}
                  >
                    {item.side}
                  </td>
                  <td className="p-4 text-sm !font-normal">
                    {formatCrypto(item.qty || 0)}{" "}
                    {getAssetName(item?.asset_name)}
                  </td>
                  <td className="p-4 text-sm !font-normal">
                    {formatCrypto(item.price || 0)} {item.asset_name?.split("/")?.[1] || "USDT"}
                  </td>
                  <td className="p-4 text-sm !font-normal">
                    {formatCurrency(item.usdt_qty || 0)} {item.asset_name?.split("/")?.[1] || "USDT"}
                  </td>
                  <td className="p-4 text-sm !font-normal">
                    {moment(item.created_at).format("DD/MM/YYYY HH:mm")}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={8}
                  className="h-[10rem] text-center text-sm text-gray-400 py-8"
                >
                  No data found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="items-center justify-center mt-4 md:mt-6 flex">
        <Pagination
          currentPage={page}
          totalPages={histories?.pagination?.max_page || 1}
          onPageChange={setPage}
        />
      </div>
    </div>
  );
};

export default TablePortoHistory;
